import classnames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { isNotNull } from '../../utils/nonNull'
import { Grid } from '../Grid/Grid'
import { SideBannerMask } from './SideBannerMask'
import { TopBannerMask } from './TopBannerMask'
import pageBannerStyles from './pageBanner.module.scss'


enum BannerTypes {
  TOP_BANNER = 'top_banner',
  SIDE_BANNER = 'side_banner',
}

export type PageBannerComponentProps = {
  bannerType: string
  defaultContentData?: {title: string; description?:string}
  children?: React.ReactNode
  src?: string
  mobileSrc?: string
  isBlogListing?: boolean
}

export const PageBannerComponent:React.FC<PropsWithChildren<PageBannerComponentProps>> = ({
  children,
  bannerType,
  src,
  mobileSrc,
  isBlogListing=false })=> {
  const isTopBanner = bannerType === BannerTypes.TOP_BANNER
  const isSideBanner = bannerType === BannerTypes.SIDE_BANNER
  const bannerStyles = [pageBannerStyles.pageBannerContentWrapper]

  if (isTopBanner) bannerStyles.push(pageBannerStyles['top-banner'])

  if (isSideBanner) bannerStyles.push(pageBannerStyles['side-banner'])

  return (
    <div>
      {isSideBanner && pageBannerStyles.sideBanner && (<div className={pageBannerStyles.sideBannerWrapper}><SideBannerMask src={isNotNull(src) ? src : ''} className={pageBannerStyles.sideBanner} isBlogListing={isBlogListing} /></div>)}
      {isTopBanner && pageBannerStyles.topBanner && (<div className={pageBannerStyles.topBannerWrapper}><TopBannerMask src={isNotNull(src) ? src : ''} mobileSrc={isNotNull(mobileSrc) ? mobileSrc : ''} className={pageBannerStyles.topBanner} /></div>)}
      <Grid container className={classnames(bannerStyles)}>
        {children && children}
      </Grid>
    </div>
  )
}


